import React from 'react';
import { footer } from '../data/mock';

const Footer = () => {
  return (
    <footer className="py-12 px-4 md:px-6 border-t border-black/5">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Brand */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
              {footer.brand}
            </h3>
            <p className="body-small max-w-xs" style={{ color: 'var(--text-secondary)' }}>
              {footer.description}
            </p>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6">
            {footer.links.map((link) => (
              <a
                key={link.label}
                href={link.url || link.href}
                target={link.url ? '_blank' : undefined}
                rel={link.url ? 'noopener noreferrer' : undefined}
                className="nav-link"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-black/5 text-center">
          <p className="body-small" style={{ color: 'var(--text-muted)' }}>
            {footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
